import { jsxs as t, Fragment as p, jsx as e } from "react/jsx-runtime";
import a from "./FieldWrapper.js";
import i from "./Form.js";
import s from "./ImageInput.js";
import l from "./InputWrapper.js";
import m from "./Label.js";
import d from "./TextInput.js";
import c from "./Icon.js";
import { M as o } from "./chunks/index-B8d-pCoN.js";
const q = ({ modal: r, onSubmit: n }) => /* @__PURE__ */ t(p, { children: [
  /* @__PURE__ */ e(
    "button",
    {
      "aria-label": "Upload an image",
      className: "flex font-bold font-secondary gap-2 items-center text-sm uppercase",
      onClick: r.open,
      type: "button",
      children: /* @__PURE__ */ e(c, { name: "image", className: "text-lg" })
    }
  ),
  /* @__PURE__ */ t(o, { className: "text-left", modal: r, children: [
    /* @__PURE__ */ e(o.Heading, { children: "Add image" }),
    /* @__PURE__ */ t(i, { className: "items-stretch", onSubmit: n, children: [
      /* @__PURE__ */ t(a, { children: [
        /* @__PURE__ */ e(m, { className: "sr-only", isRequired: !0, children: "Image" }),
        /* @__PURE__ */ e(
          l,
          {
            input: s,
            name: "image",
            size: "full",
            validations: {
              allowedTypes: ["jpeg", "png", "webp"],
              required: !0
            }
          }
        )
      ] }),
      /* @__PURE__ */ t(a, { className: "w-full", children: [
        /* @__PURE__ */ e(m, { isRequired: !0, children: "Alt text" }),
        /* @__PURE__ */ e(
          l,
          {
            input: d,
            name: "alt",
            placeholder: "https://www.example.com",
            validations: { required: !0 }
          }
        )
      ] }),
      /* @__PURE__ */ e(i.Button, { children: "Upload" })
    ] })
  ] })
] });
export {
  q as default
};
